import PropTypes from 'prop-types';
import React, { useState, useRef, useCallback, useEffect } from 'react';

import ReactHtmlParser from 'react-html-parser';

import Button            from '@mui/material/Button';
import Dialog            from '@mui/material/Dialog';
import DialogActions     from '@mui/material/DialogActions';
import DialogContent     from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import Grid              from '@mui/material/Grid';

const SCROLL_THRESHOLD_PX = 20;

function PrivacyPolicyPopUp(props) {
  const { onConfirm, show, content, footer } = props;
  const [hasScrolledToBottom, setHasScrolledToBottom] = useState(false);
  const contentRef = useRef(null);

  useEffect(() => {
    if (show) {
      setHasScrolledToBottom(false);
    }
  }, [show]);

  const checkOverflow = useCallback(() => {
    const el = contentRef.current;
    if (el) {
      const hasOverflow = el.scrollHeight > el.clientHeight;
      setHasScrolledToBottom(!hasOverflow);
    }
  }, []);

  const handleScroll = useCallback((event) => {
    const { scrollTop, scrollHeight, clientHeight } = event.target;
    if (scrollTop + clientHeight >= scrollHeight - SCROLL_THRESHOLD_PX) {
      setHasScrolledToBottom(true);
    }
  }, []);

  return (
    <Dialog
      aria-label="Privacy policy"
      open={show}
      scroll={'paper'}
      fullWidth={true}
      maxWidth={'md'}
      TransitionProps={{ onEntered: checkOverflow }}
    >
      <DialogContent dividers ref={contentRef} onScroll={handleScroll}>
        <DialogContentText
          tabIndex={-1}
          component="div"
        >
          { ReactHtmlParser(content) }
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Grid container item spacing={2}>
          <Grid item xs={12} sx={{ mx: 2, mt: 2 }}>
            { ReactHtmlParser(footer) }
          </Grid>

          <Grid item xs={12} sx={{ justifyContent: 'flex-end', alignItems: 'flex-end' }}>
            <Button
              sx={{ my: 2, mx: 2, float: 'right' }}
              variant="contained"
              color="primary"
              onClick={onConfirm}
              data-testid="confirm_button"
              disabled={!hasScrolledToBottom}
              aria-label={t('eos.landing_page.text.scroll_to_continue')}
            >
              {t('eos.landing_page.label.continue')}
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
}

PrivacyPolicyPopUp.propTypes = {
  onConfirm: PropTypes.func,
  show:      PropTypes.bool,
  content:   PropTypes.string,
  footer:    PropTypes.string,
};

export default PrivacyPolicyPopUp;
